/**
 * Returns whether Google SSO should be shown.
 *
 * Requires VITE_GOOGLE_CLIENT_ID to be set (technical requirement).
 */
export function useGoogleSSOEnabled(): boolean {
  return !!import.meta.env.VITE_GOOGLE_CLIENT_ID
}
